// Entregas por Segmento — count of checked-out rentals in the period,
// pivoted Carga / Pasajeros / Sedanes × CP / LP / Total.
import supabase from "../../../supabase-client";

export const deliveriesBySegmentReport = {
  id: "deliveries-by-segment",
  title: "Entregas por Segmento",
  description: "Cantidad de entregas (checked_out) por segmento de auto y sucursal en el periodo. Incluye unidades subarrendadas.",
  category: "Operaciones",
  filters: [
    { type: "daterange", fromKey: "from", toKey: "to", label: "Periodo", required: true },
  ],
  pivot: {
    rowKey: "segment",
    colKey: "branch",
    valueKey: "value",
    rowLabel: "Entregas",
    rowOrder: ["Carga", "Pasajeros", "Sedanes"],
    colOrder: ["CP", "LP"],
    format: (v) => Math.round(v),
    exportType: "integer",
  },
  async fetch({ from, to }) {
    if (!from || !to) throw new Error("Seleccionar periodo");
    const { data, error } = await supabase.rpc("report_deliveries_segment", {
      p_from: from, p_to: to,
    });
    if (error) throw error;
    return data || [];
  },
};
